import BaseModel from '../../../models/base';

const LibraryModel = BaseModel.extend({
    idAttribute: 'branchId'
});

export default LibraryModel;
